export default __webpack_public_path__ + "static/media/TabOne.93d6a509.png";